import { useEffect, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { IntroGate } from "@/components/IntroGate";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Story } from "@/components/Story";
import { Teaser } from "@/components/Teaser";
import { Characters } from "@/components/Characters";
import { Season } from "@/components/Season";
import { Audience } from "@/components/Audience";
import { Positioning } from "@/components/Positioning";
import { Saga } from "@/components/Saga";
import { RequestDeck } from "@/components/RequestDeck";
import { Footer } from "@/components/Footer";

function App() {
    const [entered, setEntered] = useState(false);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    useEffect(() => {
        if (!entered) {
            document.body.style.overflow = "hidden";
            window.__lenis?.stop();
        } else {
            document.body.style.overflow = "";
            window.__lenis?.start();
        }
    }, [entered]);

    return (
        <div className="min-h-screen">
            <AnimatePresence>
                {!entered && <IntroGate onEnter={() => setEntered(true)} />}
            </AnimatePresence>
            <Header />
            <main>
                <Hero start={entered} />
                <Marquee />
                <Story />
                <Teaser />
                <Characters />
                <Season />
                <Audience />
                <Positioning />
                <Saga />
                <RequestDeck />
            </main>
            <Footer />
            <Toaster theme="dark" position="bottom-right" />
        </div>
    );
}

export default App;
